module.exports = __webpack_public_path__ + "media/images/image-placeholder-b59f01de.png";